import TomSelect from "tom-select";

// .selectpicker (旧 bootstrap-select) を Tom Select で初期化する。
// 銀行/支店プルダウンは 1,000 件超の選択肢を検索付きで選ぶ必要があり
// (低IT リテラシー配慮 #2250 系)、native select では実用に耐えないため
// 検索付きウィジェットを維持する。旧 bootstrap-select + jQuery 依存を撤去 (#2428)。

const OPTIONS = {
  // 全角で入力されても半角オプションにヒットするよう正規化して検索する。
  // (口座番号等と同様に全角→半角を無言で受容する #2250 の方針)
  diacritics: true,
  maxOptions: null, // 1,146 行の銀行を全件検索可能にする(先頭 N 件で切らない)
  placeholder: "選択してください（入力して検索）",
  // 元 select の値が空(未選択)のとき Tom Select が最初の option を勝手に
  // 選ばないようにする。
  allowEmptyOption: true,
};

// 指定スコープ内の .selectpicker を Tom Select 化する。既に初期化済みの
// 要素はスキップする。
const initSelectpickerIn = (root = document) => {
  const selects = root.querySelectorAll("select.selectpicker");
  selects.forEach((el) => {
    if (el.tomselect) return;
    // eslint-disable-next-line no-new
    new TomSelect(el, OPTIONS);
  });
};

const init = () => initSelectpickerIn(document);

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
